import { object, array, number, string, picklist } from 'valibot';

export const articleMetricSchema = {
	download_count: number(),
	view_count: number(),
};

export const articleSchema = object({
	id: number(),
	name: string(),
	content: array(string()),
	type: picklist(['group', 'article']),
	file: string(),
	slug_path: string(),
	first_publish_date: string(),
	updated_at: string(),
	dictionary_name: string(),
	...articleMetricSchema,
});

// export const articleGroupSchema = () => {
// 	return variant('content', [
// 		object({
// 			id: number(),
// 			name: string(),
// 			content: array(articleSchema),
// 			type: string(),
// 		}),
// 		object({
// 			id: number(),
// 			name: string(),
// 			content: array(articleGroupSchema()),
// 			type: string(),
// 		}),
// 	]);
// };
